import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { blockingFetchService } from '../../lib/blockingFetch'
import apiServerApi from '../../redux/sagas/apiServerApi'
import {
  addOrUpdateDownloadRequest,
  replaceDownloadRequests,
  removeDownloadRequest,
  selectors as downloadRequestSelectors,
} from '../../redux/downloadRequests'
import './downloadRequestPopover.css'
import NavbarButton from '../App/NavbarButton'
import DownloadRequestItem from './DownloadRequestItem'

class DownloadRequestPopover extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      open: false,
    }

    this.triggerRef = null
    this.popoverRef = null
    this.statusInterval = null
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleDocumentClick)
    blockingFetchService(
      accessToken => apiServerApi.getDownloadRequests(accessToken),
      responses => {
        const requests = Array.isArray(responses) ? responses : []
        this.props.replaceDownloadRequests(requests)
        this.refreshPollingState()
      },
      error => {
        console.error('Unable to load download requests', error)
      },
      () => {}
    )

    this.refreshPollingState()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.downloadRequests !== this.props.downloadRequests) {
      this.refreshPollingState()
    }
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleDocumentClick)
    if (this.statusInterval) {
      clearInterval(this.statusInterval)
      this.statusInterval = null
    }
  }

  setTriggerRef = node => {
    this.triggerRef = node
  }

  setPopoverRef = node => {
    this.popoverRef = node
  }

  getPendingRequests = () => (this.props.downloadRequests || []).filter(request => 
    request && (request.status === 'PENDING' || request.status === 'IN_PROGRESS')
  )

  refreshPollingState = () => {
    const activeRequests = this.getPendingRequests()
    if (activeRequests.length > 0) {
      if (!this.statusInterval) {
        this.statusInterval = setInterval(this.checkDownloadStatuses, 5000)
      }
    }
    else if (this.statusInterval) {
      clearInterval(this.statusInterval)
      this.statusInterval = null
    }
  }

  handleDocumentClick = event => {
    const target = event.target
    if (this.state.open && this.popoverRef && !this.popoverRef.contains(target) && this.triggerRef && !this.triggerRef.contains(target)) {
      this.setState({ open: false })
    }
  }

  toggleOpen = () => {
    this.setState(prevState => ({ open: !prevState.open }))
  }

  checkDownloadStatuses = () => {
    const activeRequests = this.getPendingRequests()
    if (!activeRequests.length) {
      this.refreshPollingState()
      return
    }

    const ids = activeRequests.map(request => request.id)

    blockingFetchService(
      accessToken => apiServerApi.checkDownloadRequestStatuses(accessToken, ids),
      responses => {
        if (!Array.isArray(responses)) return

        responses.forEach(request => {
          this.props.addOrUpdateDownloadRequest(request)
        })

        const stillActive = responses.some(request => request && (request.status === 'PENDING' || request.status === 'IN_PROGRESS'))
        if (!stillActive) {
          if (this.statusInterval) {
            clearInterval(this.statusInterval)
            this.statusInterval = null
          }
        }
      },
      error => {
        console.error('Unable to refresh download request statuses', error)
      },
      () => {}
    )
  }

  render() {

    const { open } = this.state,
    items = this.props.downloadRequests || [],
    count = items.length

    return (
      <div className='relative'>
        <NavbarButton
          innerRef={ this.setTriggerRef }
          onClick={ this.toggleOpen }
          count={ count }
          ariaExpanded={ open }
          iconName="download"
          iconBgColor="bg-red-600"
          title="Report generation requests"
        />

        { open && (
          <div ref={ this.setPopoverRef } className="dr-popover">
            <div className="dr-header">
              <h2 className="dr-title">Report requests</h2>
              <p className="dr-subtitle">{ count } { count === 1 ? 'request' : 'requests' }</p>
            </div>

            <div className="dr-body">
              { !items.length ? (
                <div className="dr-empty">
                  No download requests.
                </div>
              ) : ( items.map(request => (
                  <DownloadRequestItem
                    key={ request.id }
                    request={ request }
                    removeDownloadRequest={ this.props.removeDownloadRequest }
                  />
                ))
              )}
            </div>
          </div>
        )}
      </div>
    )
  }
}

DownloadRequestPopover.propTypes = {
  downloadRequests: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      reportName: PropTypes.string,
      outputType: PropTypes.string,
      createdAt: PropTypes.string,
      updatedAt: PropTypes.string,
      status: PropTypes.string,
      errorMessage: PropTypes.string,
      fileName: PropTypes.string,
    })
  ),
  addOrUpdateDownloadRequest: PropTypes.func,
  replaceDownloadRequests: PropTypes.func,
  removeDownloadRequest: PropTypes.func,
}

const mapStateToProps = state => ({
  downloadRequests: downloadRequestSelectors.all(state),
})

const mapDispatchToProps = {
  addOrUpdateDownloadRequest,
  replaceDownloadRequests,
  removeDownloadRequest,
}

export default connect(mapStateToProps, mapDispatchToProps)(DownloadRequestPopover)



// WEBPACK FOOTER //
// ./src/components/DownloadRequests/DownloadRequestPopover.js